<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="restaurant_breadcrumb" />
    </div>
    <div class="header">
      <!--      <h1 class="overlay">RESTAURANT</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="contentDesc">
        <div class="title1">
          <h2>
            <strong>추천메뉴 & 프로모션</strong>
          </h2>
        </div>
      </div>
      <div class="row rowSpace"></div>
      <div class="itemMain">
        <span> [ {{ item.type }}] {{ item.title }} </span>
      </div>

      <hr />
      <table class="itemIntro table-borderless">
        <tr>
          <th>메뉴</th>
          <td>{{ item.menu }}</td>
        </tr>
        <tr>
          <th>판매기간</th>
          <td>{{ item.date }}</td>
        </tr>
        <tr>
          <th>운영시간</th>
          <td>{{ item.time }}</td>
        </tr>
        <tr>
          <th>가격</th>
          <td>{{ item.price }}</td>
        </tr>
      </table>
      <hr />

      <div class="row rowSpace"></div>
      <!--      <div class="row">-->
      <div class="row itemCate">
        <div v-html="cvtCrToBr(item.desc)"></div>
      </div>
      <hr />
      <div class="col buttonArea">
        <button class="prev-button" @click="$router.go(-1)">이전</button>
      </div>
      <div class="row rowSpace"></div>
      <div class="row rowSpace"></div>
    </div>
  </div>
</template>

<script>
import boardService, {BoardParam} from '@/services/board.service';
import diningPromotion from '@/pages/MainPage/Components/DiningPromotion';
import GeneralUtil from '@/util/GeneralUtil';
import {BoardArticle} from '@/models';
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import DiningPromotion from '@/pages/MainPage/Components/DiningPromotion';
import {RESTAURANT_BOARD_ID} from '@/pages/MainPage/Components/DiningPromotionBoardId';

export default {
  name: 'DiningPromotionDetail',
  mixins: [GeneralUtil],
  data() {
    return {
      id: this.$route.params.id,
      item: {},
      restaurant_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'DINING',
        present: '추천메뉴 & 프로모션',
      },
    };
  },
  async created() {
    console.log('this.id-----', this.id);
    //this.item = diningPromotion.data().items[this.id];
    let subtitle5 = this.$route.params.id;
    console.log(subtitle5);

    // let p = new BoardParam(RESTAURANT_BOARD_ID);
    // p.subtitle1Search = this.showSignatureMode ? 'SIGNATURE MENU' : null;
    // const aList = await boardService.getArticleListObjParam(p);
    // const items = aList.map(x => {
    //   let item = {
    //     id: x.id,
    //     type: x.subtitle1,
    //     title: x.title,
    //     menu: x.subtitle2,
    //     time: x.subtitle4,
    //     price: x.subtitle5,
    //     desc: x.memo,
    //     thumbnail: x.getFirstAttachFileUrl(true),
    //     image: x.getFirstAttachFileUrl(true),
    //   };
    //
    //   return item;
    // });
    //
    // if (items.length > 0) {
    //   this.item = items[0];
    // }
    const result = await boardService.getArticleById(RESTAURANT_BOARD_ID, 'BoardArticleDetailWithFiles', this.id);
    const aList = result._embedded.boardArticles.map(x => new BoardArticle(x));
    console.log(aList);
    const items = aList.map(x => {
      let item = {
        id: x.id,
        type: x.subtitle1,
        title: x.title,
        menu: x.subtitle2,
        date: x.subtitle3,
        time: x.subtitle4,
        price: x.subtitle5,
        desc: x.memo,
        thumbnail: x.getFirstAttachFileUrl(true),
        image: x.getFirstAttachFileUrl(true),
      };

      return item;
    });

    if (items.length > 0) {
      this.item = items[0];
    }
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: '추천메뉴 & 프로모션'});
  },
  components: {
    Breadcrumb,
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  justify-content: center;
}
.top {
  padding-top: 11rem;
}

.itemMain {
  font-size: 1.8rem;
  padding: 1rem 0rem;
  display: flex;
  justify-content: center;
  > span {
  }
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: center;

  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
table {
  tr {
    th {
      width: 30% !important;
      padding: 0.5rem !important;
      text-align: left;
    }
    td {
      width: 70% !important;
      padding: 0.5rem !important;
      text-align: left;
    }
  }
}
.itemIntro {
  width: 70%;
  font-size: 1rem;
  justify-content: center;
  text-align: center;
  margin: 0rem auto;
}
.overlay {
  color: White;
  position: absolute;
  z-index: 12;
  top: 30%;
  left: 0;
  width: 100%;
  text-align: center;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
.itemImage {
  width: 100%;
  text-align: center;
}
.itemCate {
  font-size: 1rem;
  word-break: keep-all;
  margin: 1rem 0rem;
  padding: 0 1rem;
  text-align: center;
  min-height: 10rem;
}
.itemName {
  font-size: 1.2rem;
}
.itemDesc {
  width: 60%;
  font-size: 0.9rem;
  line-height: 2rem;
  letter-spacing: -0.05rem;
  text-align: center;
}
.rowSpace {
  height: 1rem;
}
@media (min-width: 992px) {
  .main-ex-desc {
    vertical-align: bottom;
  }
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/biotopia/restaurant_headerimage.jpg');
  }
}

@media (max-width: 992px) {
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;

    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .itemImage {
    img {
      width: 100%;
    }
  }
}
</style>
